import type {
  Event,
  IncidentsQueuePostDTO,
  IncidentsQueuePostResponse,
} from '@collector/sportsapi-client-legacy'

import { HttpClient } from '../../httpClient.js'

export type IncidentsQueuePostPayload = IncidentsQueuePostDTO

export type { IncidentsQueuePostResponse }

/**
 * Insert incident to queue
 *
 * `/v2/events/{eventId}/incidents-queue`
 */
export async function post(
  httpClient: HttpClient,
  eventId: Event['id'],
  uuid: string,
  payload: { incident: IncidentsQueuePostDTO },
): Promise<IncidentsQueuePostResponse> {
  return httpClient
    .url(`/events/${eventId}/incidents-queue`)
    .query({ uuid })
    .post(payload)
    .json()
}
